import React from "react";
import { Helmet } from "react-helmet";

export default function Disclimer() {
  return (
    <div>
      <Helmet>
        <title>Disclimer || TamizhTechie</title>
        <meta name="description" content="Privacy Policy" />
      </Helmet>
      <div className="privacypolicy">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>Disclaimer</h1>
              <h2>Last updated: July 07, 2021</h2>
              <h3>Interpretation and Definitions</h3>
              <br />
              <h4>Interpretation</h4>
              <h6>
                The words of which the initial letter is capitalized have
                meanings defined under the following conditions. The following
                definitions shall have the same meaning regardless of whether
                they appear in singular or in plural.
              </h6>
              <h4>Definitions</h4>
              <p>For the purposes of this Disclaimer:</p>
              <ul>
                <li>
                  Company (referred to as either "the Company", "We", "Us" or
                  "Our" in this Disclaimer) refers to TamizhTechie.
                </li>
                <li>Service refers to the Website.</li>
                <li>
                  You means the individual accessing the Service, or the
                  company, or other legal entity on behalf of which such
                  individual is accessing or using the Service, as applicable.
                </li>
                <li>
                  Website refers to TamizhTechie, accessible from
                  <a href="https://tamizhtechie.com">
                    https://tamizhtechie.com
                  </a>
                </li>
              </ul>
              <h3>Disclaimer</h3>
              <h6>
                he information contained on the Service is for general
                information purposes only.
              </h6>
              <h6>
                The Company assumes no responsibility for errors or omissions in
                the contents of the Service. <br />
                <br />
                In no event shall the Company be liable for any special, direct,
                indirect, consequential, or incidental damages or any damages
                whatsoever, whether in an action of contract, negligence or
                other tort, arising out of or in connection with the use of the
                Service or the contents of the Service. The Company reserves the
                right to make additions, deletions, or modifications to the
                contents on the Service at any time without prior notice. <br />
                <br />
                The Company does not warrant that the Service is free of viruses
                or other harmful components. <br />
                <br />
              </h6>
              <h3>External Links Disclaimer</h3>
              <h6>
                The Service may contain links to external websites that are not
                provided or maintained by or in any way affiliated with the
                Company. <br />
                <br />
                Please note that the Company does not guarantee the accuracy,
                relevance, timeliness, or completeness of any information on
                these external websites. <br />
                <br />
              </h6>
              <h3>Errors and Omissions Disclaimer</h3>
              <h6>
                The information given by the Service is for general guidance on
                matters of interest only. Even if the Company takes every
                precaution to insure that the content of the Service is both
                current and accurate, errors can occur. Plus, given the changing
                nature of laws, rules and regulations, there may be delays,
                omissions or inaccuracies in the information contained on the
                Service. <br />
                The Company is not responsible for any errors or omissions, or
                for the results obtained from the use of this information.{" "}
                <br />
                <br />
              </h6>
              <h3>Fair Use Disclaimer</h3>
              <h6>
                The Company may use copyrighted material which has not always
                been specifically authorized by the copyright owner. The Company
                is making such material available for criticism, comment, news
                reporting, teaching, scholarship, or research. <br /> <br />
                If You wish to use copyrighted material from the Service for
                your own purposes that go beyond fair use, You must obtain
                permission from the copyright owner. <br />
                <br />
              </h6>
              <h3>Views Expressed Disclaimer</h3>
              <h6>
                The Service may contain views and opinions which are those of
                the authors and do not necessarily reflect the official policy
                or position of any other author, agency, organization, employer
                or company, including the Company. <br />
                <br />
                Comments published by users are their sole responsibility and
                the users will take full responsibility, liability and blame for
                any libel or litigation that results from something written in
                or as a direct result of something written in a comment. The
                Company is not liable for any comment published by users and
                reserve the right to delete any comment for any reason
                whatsoever. <br />
                <br />
              </h6>
              <h3>No Responsibility Disclaimer</h3>
              <h6>
                The information on the Service is provided with the
                understanding that the Company is not herein engaged in
                rendering legal, accounting, tax, or other professional advice
                and services. As such, it should not be used as a substitute for
                consultation with professional accounting, tax, legal or other
                competent advisers. <br />
                <br />
                In no event shall the Company or its suppliers be liable for any
                special, incidental, indirect, or consequential damages
                whatsoever arising out of or in connection with your access or
                use or inability to access or use the Service. <br />
                <br />
              </h6>
              <h3>"Use at Your Own Risk" Disclaimer</h3>
              <h6>
                All information in the Service is provided "as is", with no
                guarantee of completeness, accuracy, timeliness or of the
                results obtained from the use of this information, and without
                warranty of any kind, express or implied, including, but not
                limited to warranties of performance, merchantability and
                fitness for a particular purpose. <br />
                <br />
                The Company will not be liable to You or anyone else for any
                decision made or action taken in reliance on the information
                given by the Service or for any consequential, special or
                similar damages, even if advised of the possibility of such
                damages. <br />
                <br />
              </h6>
              <h3>Contact Us</h3>
              <h6>
                If you have any questions about this Disclaimer, You can contact
                Us:
              </h6>
              <ul>
                <li>
                  By email:{" "}
                  <a href="emailto:tamizhtechie@gmail.com">
                    tamizhtechie@gmail.com
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
